import React, { useState, useEffect, useRef } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";

const Record = ({
  setAudioRecording,
  onStart,
  onStop,
  setAudioInput,
  isLoading,
  setIsUserQueyLoading,
  isDarkModeInternal,
  setCopyToTextArea,
  setCancelAudio,
  setIsVoiceProcessing,
  setIsAudioProcessing,
}) => {
  const [recording, setRecording] = useState(false);
  const [audioUrl, setAudioUrl] = useState("");
  const [recordingTime, setRecordingTime] = useState(0);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const mediaStreamRef = useRef(null);
  const intervalRef = useRef(null);
  const isCancelledRef = useRef(false); // Add this flag

  // useEffect(() => {
  //   setAudioRecording(isRecording);
  // }, [isRecording]);

  const handleStart = async () => {
    setCopyToTextArea(false);
    setCancelAudio(false);
    setIsUserQueyLoading(true);
    setAudioRecording(true);
    setRecording(true);
    setRecordingTime(0);
    audioChunksRef.current = [];
    isCancelledRef.current = false; // Reset cancel flag
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    mediaStreamRef.current = stream;
    const mediaRecorder = new MediaRecorder(stream);
    mediaRecorder.ondataavailable = (event) => {
      audioChunksRef.current.push(event.data);
    };
    mediaRecorder.onstop = () => {
      // Check if recording was cancelled
      if (isCancelledRef.current) {
        // Don't process the audio if cancelled
        mediaStreamRef.current.getTracks().forEach((track) => track.stop());
        clearInterval(intervalRef.current);
        setIsUserQueyLoading(false);
        return; // Exit early
      }
      
      // Normal stop processing
      const audioBlob = new Blob(audioChunksRef.current, { type: "audio/mp3" });
      const audioUrl = URL.createObjectURL(audioBlob);
      setAudioUrl(audioUrl);
      if (onStop) {
        onStop(audioUrl);
      }
      setAudioInput(audioBlob);
      mediaStreamRef.current.getTracks().forEach((track) => track.stop());
      clearInterval(intervalRef.current);
      setIsUserQueyLoading(false);
    };
    mediaRecorder.start();
    mediaRecorderRef.current = mediaRecorder;
    intervalRef.current = setInterval(() => {
      setRecordingTime((prevTime) => prevTime + 1);
    }, 1000);
  };

  const handleStop = () => {
    setCopyToTextArea(false);
    setCancelAudio(false);
    setAudioRecording(false);
    setRecording(false);
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      if (mediaStreamRef.current) {
        mediaStreamRef.current.getTracks().forEach((track) => track.stop());
      }
      clearInterval(intervalRef.current);
    }
  };

  const handleCancel = () => {
    setCopyToTextArea(false);
    setCancelAudio(true);
    if (mediaRecorderRef.current && recording) {
      // Set cancel flag BEFORE stopping
      isCancelledRef.current = true;
      
      // Clear the audio chunks
      audioChunksRef.current = [];
      
      // Stop the media recorder (this will trigger onstop, but it will exit early)
      mediaRecorderRef.current.stop();
      
      // Stop all tracks to turn off the microphone
      if (mediaStreamRef.current) {
        mediaStreamRef.current.getTracks().forEach((track) => track.stop());
      }
      
      // Clear the timer
      clearInterval(intervalRef.current);
      
      // Reset states
      setAudioRecording(false);
      setRecording(false);
      setRecordingTime(0);
      setIsUserQueyLoading(false);
      setAudioUrl(null);
      setAudioInput(null);
    }
  };

  const onAddToTextArea = () => {
    setCancelAudio(false);
    setAudioRecording(false);
    setRecording(false);
    setCopyToTextArea(true);
    setIsVoiceProcessing(true); // <-- Add this line, pass as prop from parent
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      if (mediaStreamRef.current) {
        mediaStreamRef.current.getTracks().forEach((track) => track.stop());
      }
      clearInterval(intervalRef.current);
    }
  }

  return (
    <div>
      {recording ? (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <button
            title="Add To Query"
            onClick={onAddToTextArea}
            style={{
              opacity: isLoading ? 0.5 : 1,
              borderRadius: "8px",
              border: "1px solid var(--border-color)",
              background: "transparent",
              color: "var(--text)",
              width: "40px",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: isLoading ? "not-allowed" : "pointer",
            }}
            disabled={isLoading}
          >
            <i className="bi bi-journal-text" style={{ fontSize: "20px", opacity: ".8" }}></i>
          </button>
          
          <button
            onClick={handleCancel}
            title="Cancel Recording"
            style={{
             
              // borderRadius: "50%",
              // width: "40px",
              // height: "40px",
              // display: "flex",
              // alignItems: "center",
              // justifyContent: "center",
              // border: "none",
              // cursor: "pointer",
              borderRadius: "8px",
              border: "1px solid var(--border-color)",
              background: "var(--background)",
              color: "var(--text)",
              width: "40px",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <i class="bi bi-x-lg" style={{color:"red",fontWeight:"bold"}}></i>
          </button>

          <button
            onClick={handleStop}
            title="Stop and Send"
            style={{
              background: "red",
              color: "white",
              borderRadius: "50%",
              width: "40px",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "none",
              cursor: "pointer",
            }}
          >
            <i className="bi bi-stop-fill"></i>
          </button>

          <span style={{ color: "var(--text)" }}>{recordingTime}s</span>

        </div>
      ) : (
        <button
          title="Start Recording"
          onClick={handleStart}
          style={{
            opacity: isLoading ? 0.5 : 1,
            borderRadius: "8px",
            border: "1px solid var(--border-color)",
            background: "transparent",
            color: "var(--text)",
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: isLoading ? "not-allowed" : "pointer",
          }}
          disabled={isLoading}
        >
          <i className="bi bi-record-circle" style={{ fontSize: "20px", opacity: ".6" }}></i>
        </button>
      )}
    </div>
  );
};

export default Record;